const pill = document.querySelector('.our-values__divider--pill');
const wrapper = document.querySelector('.our-values__wrapper');
const grids = document.querySelectorAll('.our-values__grid');

function isWrapperPartiallyInView() {
  const rect = wrapper.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

window.addEventListener('scroll', () => {
  if (isWrapperPartiallyInView()) {
    const wrapperTopRelativeToViewport = wrapper.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;
    const scrollDistance = Math.max(0, -wrapperTopRelativeToViewport + viewportHeight / 3);
    const twoThirdsOfViewport = (viewportHeight * 2) / 3;
    let pillPosition = scrollDistance;

    // Check if the wrapper's top is above two-thirds of the viewport
    if (
      wrapperTopRelativeToViewport < twoThirdsOfViewport &&
      wrapperTopRelativeToViewport > -wrapper.offsetHeight + (viewportHeight - twoThirdsOfViewport)
    ) {
      pill.style.transform = `translateY(${pillPosition}px)`;
    }

    grids.forEach((grid) => {
      const gridRect = grid.getBoundingClientRect();
      const pillRect = pill.getBoundingClientRect();

      if (pillRect.top < gridRect.bottom && pillRect.bottom > gridRect.top) {
        grid.classList.add('is-active');
      } else {
        grid.classList.remove('is-active');
      }
    });
  }
});
